/**
 * useAuth
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import AuthContext from './auth-context'

function useAuth() {
  const context = useContext(AuthContext)
  return context
}

export default useAuth
